const MONTHS = ['januar', 'februar', 'mars', 'april', 'mai', 'juni', 'juli', 'august', 'september', 'oktober', 'november', 'desember'];
export const addLeadingZeroOnSingle = input => String(input).padStart(2, '0');
export const validDate = date => date instanceof Date;
export const toDateObj = date => new Date(date);
export const formatDateToDateMonth = date => {
  const dateObj = toDateObj(date);
  if (validDate(dateObj)) {
    return "".concat(addLeadingZeroOnSingle(dateObj.getDate()), ".").concat(addLeadingZeroOnSingle(dateObj.getMonth() + 1));
  }
  return 'Ingen dato';
};
export const formatDateToDateMonthName = date => {
  const dateObj = toDateObj(date);
  if (validDate(dateObj)) {
    return "".concat(dateObj.getDate(), ". ").concat(MONTHS[dateObj.getMonth()]);
  }
  return 'Ingen dato';
};
export const formatDateToYear = date => {
  const dateObj = toDateObj(date);
  if (validDate(dateObj)) {
    return dateObj.getFullYear();
  }
  return undefined;
};
export const dateToPretty = function (date) {
  let monthAsName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (date === null || typeof date === 'undefined') {
    return 'Ingen dato';
  }
  const dateObj = toDateObj(date);
  if (validDate(dateObj)) {
    if (!monthAsName) {
      return "".concat(formatDateToDateMonth(dateObj), ".").concat(formatDateToYear(dateObj));
    }
    return "".concat(formatDateToDateMonthName(dateObj), " ").concat(formatDateToYear(dateObj));
  }
  return 'Ingen dato';
};
export const areSameDates = (dateA, dateB) => dateA.getFullYear() === dateB.getFullYear() && dateA.getMonth() === dateB.getMonth() && dateA.getDate() === dateB.getDate();